"use strict";

;

(function PPVXAccordion(win) {
  var PPVX = win.PPVX;
  /* Focus a particular element */

  function buttonFocus(sibling) {
    if (sibling != null) {
      var buttons = sibling.getElementsByTagName('button');

      if (buttons && buttons.length > 0) {
        buttons[0].focus();
      }
    }
  }
  /* Callback for click event */


  function clickListener(event) {
    var element = event.target.parentElement || event.target.parentNode;

    if (element.classList && element.classList.contains('ppvx_accordion__row')) {
      var toggleButton = element.querySelector('button');
      var isExpanded = toggleButton.getAttribute('aria-expanded');

      if (isExpanded === 'true') {
        toggleButton.setAttribute('aria-expanded', 'false');
      } else {
        toggleButton.setAttribute('aria-expanded', 'true');
      }

      buttonFocus(element);
    }
  }

  function Accordion() {}

  PPVX.registerObject(Accordion, 'Accordion');
  PPVX.clickWatcher.addWatcher(Accordion.name, clickListener);
})(window);